"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiDesktop16 = {
    paths: [
        {
            path: 'M5,12 L5,11 L1.00087166,11 C0.448105505,11 0,10.555163 0,10.0044225 L0,0.995577499 C0,0.445735229 0.444630861,0 1.00087166,0 L14.9991283,0 C15.5518945,0 16,0.444836974 16,0.995577499 L16,10.0044225 C16,10.5542648 15.5553691,11 14.9991283,11 L11,11 L11,12 L11.0029699,12 C11.5536144,12 12,12.4438648 12,13 C12,13.5522847 11.5469637,14 11.0029699,14 L4.99703014,14 C4.4463856,14 4,13.5561352 4,13 C4,12.4477153 4.45303631,12 4.99703014,12 L5,12 L5,12 Z M2,2 L2,9 L14,9 L14,2 L2,2 Z M7,11 L7,12 L9,12 L9,11 L7,11 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Desktop',
    width: 16,
    height: 14,
};
var muiDesktop24 = {
    paths: [
        {
            path: 'M22.9993054,0 C23.5519738,0 24,0.444630861 24,1.00087166 L24,14.9991283 C24,15.5518945 23.5525308,16 22.9993054,16 L15,16 L15,18 L16.0046024,18 C16.515078,18 16.935804,18.3827202 16.9933032,18.8826674 L17,19 C17,19.5522847 16.5443356,20 16.0046024,20 L7.99539757,20 C7.44565467,20 7,19.5561352 7,19 C7,18.4477153 7.4556644,18 7.99539757,18 L9,18 L9,16 L1.00069463,16 C0.448026248,16 0,15.5553691 0,14.9991283 L0,1.00087166 C0,0.448105505 0.44746922,0 1.00069463,0 L22.9993054,0 Z M13,18 L13,16 L11,16 L11,18 L13,18 Z M22,2 L2,2 L2,14 L22,14 L22,2 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Desktop',
    width: 24,
    height: 20,
};
var muiDesktop = {
    base: muiDesktop16,
    smIcon: muiDesktop16,
    lgIcon: muiDesktop24,
};
exports.muiDesktop = muiDesktop;
//# sourceMappingURL=desktop.js.map